import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { HabitacionHotel } from '../../../models/habitacion-hotel';
import { NivelHotel } from '../../../models/nivel-hotel';
import { TipoHabitacionHotel } from '../../../models/tipo-habitacion-hotel';
import { HabitacionHotelService } from '../../../services/habitacion-hotel.service';
import { NivelHotelService } from '../../../services/nivel-hotel.service';
import { SessionService } from '../../../services/session.service';
import { TipoHabitacionHotelService } from '../../../services/tipo-habitacion-hotel.service';
import { UtilsService } from '../../../services/utils.service';

@Component({
  selector: 'app-habitacion-add-modal',
  templateUrl: './habitacion-add-modal.component.html',
  styleUrls: ['./habitacion-add-modal.component.css'],
  providers: [
    NivelHotelService,
    TipoHabitacionHotelService,
    HabitacionHotelService,
  ],
})
export class HabitacionAddModalComponent implements OnInit {
  @Output() sendHabitacion = new EventEmitter();
  public nivelesHotel: Array<NivelHotel>;
  public tiposHabitacion: Array<TipoHabitacionHotel>;
  public habitacionHotel: HabitacionHotel;
  public nivel: NivelHotel;
  public nivelHotel: NivelHotel;
  public tipoHabitacion: TipoHabitacionHotel;
  public vl: Validation;
  public msg: SweetMessage;
  public calculo_decimales: number;

  public loading: boolean;
  constructor(
    public bsModalRef: BsModalRef,
    private nivelHotelService: NivelHotelService,
    private tipoHabitacionHotelService: TipoHabitacionHotelService,
    private habitacionHotelService: HabitacionHotelService,
    private ss: SessionService,
    public utils: UtilsService,
  ) {
    this.nivelesHotel = [];
    this.tiposHabitacion = [];
    this.habitacionHotel = new HabitacionHotel();
    this.nivel = null;
    this.nivelHotel = new NivelHotel();
    this.tipoHabitacion = new TipoHabitacionHotel();
    this.vl = new Validation();
    this.msg = new SweetMessage();
    this.calculo_decimales = 2;

    this.loading = false;
  }

  ngOnInit() {
    this.loading = true;
    let p1 = this.getNivelesHotel();
    let p2 = this.getTiposHabitacionHotel();

    Promise.all([p1,p2]).then(
      res => this.loading = false,
      err => this.loading = false,
    );
  }

  getNivelesHotel(){
    return new Promise((resolve, reject)=>{
      let qs = "?status=A&empresa_id=" + this.ss.getData('empresa_id');
      this.nivelHotelService.getAll(qs).subscribe(
        res =>{
          this.nivelesHotel = res.data;
          resolve();
        },
        err =>{
          reject();
        });
    });
  }

  getTiposHabitacionHotel(){
    return new Promise((resolve, reject)=>{
      let qs = "?status=A&empresa_id=" + this.ss.getData('empresa_id');
      this.tipoHabitacionHotelService.getAll(qs).subscribe(
        res =>{
          this.tiposHabitacion = res.data;
          resolve();
        },
        err =>{
          reject();
        });
    });
  }

  // onChangeNivelHotel(){
    // this.nivelHotel = this.nivel;
  // }

  isValid(){
    if(!this.habitacionHotel.codigo){
      return false;
    }

    if(this.habitacionHotel.precio == 0){
      return false;
    }

    if(!this.habitacionHotel.tipo_habitacion_id){
      return false;
    }

    if(!this.habitacionHotel.nivel_hotel_id){
      return false;
    }
    return true;
  }

  setValueEntity(){
     
    this.habitacionHotel.codigo = this.habitacionHotel.codigo.trim();
    // this.habitacionHotel.codigo = this.nivelHotel.nombre + " - " + this.habitacionHotel.nombre;
    this.habitacionHotel.detalle = this.habitacionHotel.detalle.trim();
    // this.habitacionHotel.tipo_habitacion_id = this.tipoHabitacion.id;
    // this.habitacionHotel.nivel_hotel_id = this.nivelHotel.id;
    this.habitacionHotel.precio = this.utils.redondear((this.habitacionHotel.precio), this.calculo_decimales);
    
     
    this.habitacionHotel.usuario_id = this.ss.getData('usuario_id');
    this.habitacionHotel.empresa_id = this.ss.getData('empresa_id');
  }

  onSubmit(){
    this.loading = true;
    this.setValueEntity();
		this.habitacionHotelService.save(this.habitacionHotel).subscribe(
			res => {
				this.msg.showMessage('success-message', 'Se ha procesado correctamente');
        this.loading = false;
        
        this.habitacionHotel = new HabitacionHotel();
        this.nivelHotel = new NivelHotel();
        this.getNivelesHotel();
        this.getTiposHabitacionHotel();
        this.sendHabitacion.emit(res.data);
			},
			err => {
        this.loading = false;
        this.habitacionHotel = new HabitacionHotel();
        this.nivelHotel = new NivelHotel();
        this.msg.showMessage('error-message',err);
			}
		);
  }

  // validTypeMsgForm(nombre,campo){
	// 	return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
	// }

  // validErrorForm(campo){
	// 	return this.vl.validErrorForm(campo,this.myForm);
	// }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/habitacion-add-modal/habitacion-add-modal.component.ts